<template>
  <div class="workspace-page product-playlist-library">
    <header class="workspace-heading">
      <div>
        <p class="workspace-eyebrow">
          {{ $t('product.campaign-share') }}
        </p><h1>{{ $t('product.playlist-title') }}</h1><p>{{ $t('product.playlist-copy') }}</p>
      </div><router-link
        to="/tools"
        class="button is-light"
      >
        {{ $t('navigation.tools') }} →
      </router-link>
    </header><div class="product-commandbar">
      <label class="product-search"><span>{{ $t('product.playlist-search') }}</span><input
        v-model="search"
        class="input"
        type="search"
        :placeholder="$t('product.playlist-search-hint')"
      ></label>
    </div><div
      v-if="loading"
      class="workspace-loading"
      role="status"
    >
      <IndifyLoader />
    </div><section
      v-else-if="error"
      class="product-message"
      role="alert"
    >
      <p>{{ $t('product.projects-error') }}</p><button @click="load">
        {{ $t('general.retry') }}
      </button>
    </section><div
      v-else-if="filtered.length"
      class="product-project-grid"
    >
      <article
        v-for="playlist in filtered"
        :key="playlist.id"
        class="product-project"
      >
        <img
          :src="playlist.images?.[0]?.url || placeholder"
          :alt="playlist.name"
        ><div class="product-project-content">
          <span class="workspace-eyebrow">Spotify</span><h2>{{ playlist.name }}</h2><p>{{ playlist.description }}</p><a
            v-if="playlist.external_urls?.spotify"
            class="product-text-button"
            :href="playlist.external_urls.spotify"
            target="_blank"
            rel="noopener noreferrer"
          >{{ $t('product.listen-first') }} ↗</a><router-link
            class="button is-primary"
            :to="pitchPath(playlist)"
          >
            {{ $t('product.prepare-pitch') }} →
          </router-link>
        </div>
      </article>
    </div><section
      v-else
      class="product-empty"
    >
      <h2>{{ $t('product.no-playlist-match') }}</h2><p>{{ $t('product.playlist-search-hint') }}</p>
    </section><aside class="product-next-action">
      <div><h3>{{ $t('product.pitch-with-context') }}</h3><p>{{ $t('product.pitch-context-copy') }}</p></div>
    </aside>
  </div>
</template>
<script setup>
import { ref,computed,onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import playlistsService from '@/services/playlistsService';
import IndifyLoader from '@/components/ui/IndifyLoader.vue';
import placeholder from '@/assets/images/img-placeholder.jpg';
const route=useRoute();const auth=useAuthStore();const playlists=ref([]);const search=ref('');const loading=ref(true);const error=ref(false);
const filtered=computed(() => playlists.value.filter(item => `${item.name} ${item.description||''}`.toLowerCase().includes(search.value.toLowerCase())));
function pitchPath(playlist) {const path=`/playlists/${playlist.id}/submit`;return auth.currentUser?{ path,query:{ release:route.query.release } }:{ path:'/auth/login',query:{ redirect:path } };}
async function load(){loading.value=true;error.value=false;try{const data=await playlistsService.getAll();if(!Array.isArray(data))throw new Error('Invalid playlist list');playlists.value=data;}catch{error.value=true;}finally{loading.value=false;}}
onMounted(load);
</script>
